/**
 * Account menu in the header.
 *
 * The menu itself is a native <details>, so opening, closing and keyboard support come
 * for free. What <details> doesn't give is dismissal: this closes it when the click
 * lands elsewhere, when Escape is pressed, or when another header menu takes over.
 */
(() => {
  const menus = () => document.querySelectorAll('[data-rmh-account]');

  const closeAll = (except) => {
    menus().forEach((menu) => {
      if (menu !== except) menu.open = false;
    });
  };

  document.addEventListener('click', (event) => {
    const inside = event.target.closest?.('[data-rmh-account]');
    closeAll(inside);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = [...menus()].find((menu) => menu.open);
    if (!open) return;
    open.open = false;
    open.querySelector('summary')?.focus();
  });
})();
